import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { array } from '@ember/helper';
import {
  HdsTextDisplay,
  HdsTextBody,
  HdsButtonSet,
  HdsButton,
} from '@hashicorp/design-system-components/components';
import {
  LayoutFullScreen,
  Flex,
  CoreDropDownGoToTerraform,
} from 'core/components';

/**
 *
 * `organization` is an object.
 * @argument organization;
 * @type {Object}
 * @required
 *
 */
/**
 *
 * `PageOrganizationsCreateSuccess` renders the organization create success messaging.
 *
 *
 * ```
 * <Page::Organizations::Create::Success @organization={{@organization}} />
 * ```
 *
 * @class PageOrganizationsCreateSuccess
 *
 */
export default class PageOrganizationsCreateSuccess extends Component {
  <template>
    <LayoutFullScreen data-test-organization-create-success as |FS|>
      <FS.Main>
        <:content>
          <Flex @direction="column" @gap="md">
            <HdsTextDisplay
              @tag="h1"
              @size="500"
              data-test-organization-create-success-title
            >
              {{t
                "components.page.organizations.create.success.organization-created-successfully"
              }}
            </HdsTextDisplay>
            <HdsTextBody @tag="p" data-test-organization-create-success-message>
              {{t
                "components.page.organizations.create.success.recently-announced-terraform"
                organizationName=@organization.name
              }}
            </HdsTextBody>
            <HdsButtonSet>
              <HdsButton
                @color="secondary"
                @models={{array @organization.id}}
                @route="cloud.orgs.detail"
                @text={{t
                  "components.page.organizations.create.success.go-to-hcp"
                }}
                data-test-organization-create-success-org-link
              />
              <CoreDropDownGoToTerraform
                data-test-organization-create-success-go-to-terraform-dropdown
              />
            </HdsButtonSet>
          </Flex>
        </:content>
      </FS.Main>
    </LayoutFullScreen>
  </template>
}
